/* =============================================================
   AED Professionals — Find My Pads & Batteries
   Theme asset: assets/aed-pads-finder.js
   -------------------------------------------------------------
   Deploys exactly like the TCO calculator and AED Adviser:
   1) Add this file to your theme's /assets folder.
   2) In layout/theme.liquid, add ONE line above </body>:
        <script src="{{ 'aed-pads-finder.js' | asset_url }}" defer></script>
   3) Drop the matching embed block (aed-pads-finder-shopify-embed.html)
      into a GemPages Liquid/Custom HTML element on the finder page.
   The script stays dormant on every page except the one that holds
   #aed-pads-finder, so there is zero cross-talk site-wide.
   -------------------------------------------------------------
   All handles/SKUs/prices verified against the live Admin API
   on 2026-08-25. Update the DATA block below if the catalog moves.
   Every price here mirrors one SKU — see Price_Drift_Registry.md.
   Batteries are OEM prices, not ReCelled: M5070A is 249, M5070A-ABE is 154.
   ============================================================= */
(function () {
  "use strict";

  var STORE = "https://aedprofessionals.com";
  var url = function (h) { return h ? STORE + "/products/" + h : null; };

  /* Verified consumables map (see aed-consumables-map.json for the full record). */
  var DATA = {
    "ZOLL": [
      { m: "ZOLL AED Plus",
        adult: { t: "ZOLL CPR-D Padz (one-piece)", h: "zoll-cpr-d-replacement-padz", p: "237.00", s: "5 yr", a: true },
        adultAlt: { t: "ZOLL CPR Stat-Padz (pair)", h: "zoll-cpr-stat-padz-electrode", p: "119.00", s: "22 mo", a: true },
        ped: { t: "ZOLL Pedi-Padz II", h: "zoll-pedi-padz-ii-electrodes", p: "131.00", s: "22 mo", a: true },
        bat: { t: "Type 123A Lithium set (10) — easiest via maintenance pkg", h: "zoll-aed-plus-maintenance-package-pads-and-battery", p: "from 340.00", s: "—", a: true, n: "AED Plus runs on ten 123A photo-lithium cells. Aviation/FAA pack also available." },
        pkg: { t: "AED Plus Pad & Battery Maintenance Package", h: "zoll-aed-plus-maintenance-package-pads-and-battery" } },
      { m: "ZOLL AED Pro",
        adult: { t: "ZOLL CPR-D Padz (one-piece)", h: "zoll-cpr-d-replacement-padz", p: "237.00", s: "5 yr", a: true },
        adultAlt: { t: "ZOLL Stat-Padz II (pair)", h: "zoll-aed-plus-pro-stat-padz-ii-electrodes", p: "77.00", s: "22 mo", a: true },
        ped: { t: "ZOLL Pedi-Padz II", h: "zoll-pedi-padz-ii-electrodes", p: "131.00", s: "22 mo", a: true },
        bat: { t: "ZOLL AED Pro Non-Rechargeable Battery", h: "zoll-aed-pro-non-rechargeable-lithium-battery-pack", p: "210.00", s: "5 yr", a: true },
        pkg: null },
      { m: "ZOLL AED 3",
        adult: { t: "ZOLL CPR Uni-Padz III (universal adult + pediatric)", h: "zoll-cpr-uni-padz-iii", p: "248.00", s: "5 yr", a: true },
        ped: { t: "Covered by CPR Uni-Padz III — switch to child mode on the device", h: "zoll-cpr-uni-padz-iii", p: "248.00", s: "5 yr", a: true },
        bat: { t: "ZOLL AED 3 Smart Battery (LCD + Wi-Fi)", h: "zoll-aed-3-battery-pack", p: "207.00", s: "5 yr", a: true },
        pkg: { t: "AED 3 Pad & Battery Maintenance Package", h: "zoll-aed-3-maintenance-package-pads-and-battery" } }
    ],
    "Physio-Control / Stryker (LIFEPAK)": [
      { m: "LIFEPAK CR2",
        adult: { t: "LIFEPAK CR2 Electrode Pads (universal adult + child)", h: "lifepak-cr2-replacement-electrode-kit", p: "188.00", s: "2 yr", a: true },
        ped: { t: "Covered by CR2 universal pads — select child mode on the device", h: "lifepak-cr2-replacement-electrode-kit", p: "188.00", s: "2 yr", a: true },
        bat: { t: "LIFEPAK CR2 Lithium Battery", h: "lifepak-cr2-replacement-lithium-battery", p: "327.00", s: "4 yr", a: true },
        pkg: { t: "CR2 Pad & Battery Maintenance Package", h: "physio-control-lifepak-cr2-aed-electrode-pad-battery-maintenance-package" } },
      { m: "LIFEPAK 1000",
        adult: { t: "QUIK-COMBO Electrode w/ REDI-PAK Pre-Connect", h: "electrode-quik-combo-w-redi-pak-pre-connect", p: "57.00", s: "2 yr", a: true },
        ped: { t: "QUIK-COMBO Pediatric Electrode (reduced energy)", h: "electrode-replacement-infant-child-reduced-energy", p: "161.00", s: "2 yr", a: true },
        bat: { t: "LIFEPAK 1000 Battery (non-rechargeable)", h: "lifepak-1000-aed-battery", p: "507.00", s: "4 yr", a: true },
        pkg: null },
      { m: "LIFEPAK Express / CR Plus",
        adult: { t: "QUIK-COMBO Electrode w/ REDI-PAK Pre-Connect", h: "electrode-quik-combo-w-redi-pak-pre-connect", p: "57.00", s: "2 yr", a: true },
        ped: { t: "QUIK-COMBO Pediatric Electrode (reduced energy)", h: "electrode-replacement-infant-child-reduced-energy", p: "161.00", s: "2 yr", a: true },
        bat: { t: "REDI-CHARGE rechargeable battery", h: null, p: null, s: "—", a: false, n: "CR Plus / Express use a REDI-CHARGE rechargeable pack — call 888-541-2337 to match your serial." },
        pkg: null }
    ],
    "Philips": [
      { m: "HeartStart OnSite / Home (HS1)",
        adult: { t: "Philips OnSite/Home SMART Pads", h: "philips-heartstart-onsite-smart-pads-cartridge", p: "99.00", s: "2 yr", a: true },
        ped: { t: "Philips OnSite/Home Pediatric (Infant/Child) SMART Pads", h: "philips-heartstart-onsite-infant-child-smart-pads-cartridge", p: "139.00", s: "2 yr", a: true },
        bat: { t: "Philips OnSite/FRx Battery (shared)", h: "philips-heartstart-onsite-frx-battery", p: "249.00", s: "4 yr", a: true, n: "Re-celled ($154) and FAA aviation ($259) options available." },
        pkg: { t: "OnSite Pad & Battery Maintenance Package", h: "philips-heartstart-onsite-hs1-aed-maintenance-package-pads-and-battery" } },
      { m: "HeartStart FRx",
        adult: { t: "Philips FRx SMART Pads II", h: "philips-heartstart-frx-smart-pads-ii", p: "89.00", s: "2 yr", a: true },
        ped: { t: "Same SMART Pads II + Infant/Child Key (accessory)", h: "philips-heartstart-frx-smart-pads-ii", p: "89.00", s: "2 yr", a: true, n: "FRx reaches pediatric energy with the Infant/Child Key, not a separate pad." },
        bat: { t: "Philips OnSite/FRx Battery (shared)", h: "philips-heartstart-onsite-frx-battery", p: "249.00", s: "4 yr", a: true },
        pkg: { t: "FRx Pad & Battery Maintenance Package", h: "philips-heartstart-frx-aed-maintenance-package-pads-and-battery" } },
      { m: "HeartStart FR3",
        adult: { t: "Philips FR3 SMART Pads III", h: "philips-heartstart-fr3-smart-pads-iii", p: "79.00", s: "2 yr", a: true },
        ped: { t: "FR3 pediatric energy via Infant/Child Key", h: "philips-heartstart-fr3-smart-pads-iii", p: "79.00", s: "2 yr", a: true },
        bat: { t: "Philips FR3 Battery", h: "philips-heartstart-fr3-primary-battery", p: "326.00", s: "5 yr", a: true },
        pkg: null }
    ],
    "HeartSine": [
      { m: "Samaritan PAD 350P / 360P",
        note: "HeartSine combines pads and battery into a single Pad-Pak cartridge — you replace the Pad-Pak, not separate parts.",
        adult: { t: "Adult Pad-Pak (pads + battery)", h: "heartsine-samaritan-adult-pad-pak", p: "236.00", s: "4 yr", a: true, n: "Aviation adult Pad-Pak ($256) also available." },
        ped: { t: "Pediatric Pad-Pak (pads + battery)", h: "heartsine-samaritan-pediatric-pad-pak", p: "279.00", s: "4 yr", a: true },
        bat: { t: "No separate battery — it lives in the Pad-Pak", h: "heartsine-samaritan-adult-pad-pak", p: "236.00", s: "4 yr", a: true },
        pkg: { t: "Pad-Pak Maintenance Package", h: "heartsine-samaritan-pad-aed-maintenance-package-pad-pak-electrodes-battery" } },
      { m: "Samaritan PAD 450P",
        note: "HeartSine combines pads and battery into a single Pad-Pak cartridge — you replace the Pad-Pak, not separate parts.",
        adult: { t: "Adult Pad-Pak (pads + battery)", h: "heartsine-samaritan-adult-pad-pak", p: "236.00", s: "4 yr", a: true },
        ped: { t: "Pediatric Pad-Pak (pads + battery)", h: "heartsine-samaritan-pediatric-pad-pak", p: "279.00", s: "4 yr", a: true },
        bat: { t: "No separate battery — it lives in the Pad-Pak", h: "heartsine-samaritan-adult-pad-pak", p: "236.00", s: "4 yr", a: true },
        pkg: { t: "Pad-Pak Maintenance Package", h: "heartsine-samaritan-pad-aed-maintenance-package-pad-pak-electrodes-battery" } }
    ],
    "Cardiac Science (Powerheart)": [
      { m: "Powerheart G3",
        adult: { t: "Powerheart G3 Adult Electrode Pads", h: "cardiac-science-adult-electrodes", p: "81.00", s: "2 yr", a: true },
        ped: { t: "Powerheart G3 Pediatric Electrode Pads", h: "powerheart-g3-pediatric-electrodes", p: "160.00", s: "2 yr", a: true },
        bat: { t: "Powerheart G3 Battery", h: "cardiac-science-powerheart-aed-g3-battery", p: "624.00", s: "4 yr", a: true, n: "Re-celled option ($398) available." },
        pkg: { t: "G3 Pad & Battery Maintenance Package", h: "cardiac-science-g3-aed-maintenance-package" } },
      { m: "Powerheart G5",
        adult: { t: "Powerheart G5 Adult Electrode Pads (non-polarized)", h: "g5-adult-pads-non-polarized", p: "88.00", s: "2 yr", a: true },
        adultAlt: { t: "Powerheart G5 Intellisense CPR (iCPR) Pads", h: "intellisense-cpr-feedback-icpr-pads", p: "282.00", s: "2 yr", a: true },
        ped: { t: "Powerheart G5 Pediatric Electrode Pads", h: "g5-pediatric-pads-2-year", p: "127.00", s: "2 yr", a: true },
        bat: { t: "Powerheart G5 Battery (4-year guarantee)", h: "g5-battery-lithium-non-rechargeable-4-year-guarantee", p: "495.00", s: "4 yr", a: true, n: "Re-celled option ($295) available." },
        pkg: { t: "G5 Pad & Battery Maintenance Package", h: "cardiac-science-g5-aed-maintenance-package" } }
    ],
    "Defibtech (Lifeline)": [
      { m: "Lifeline / Lifeline AUTO",
        adult: { t: "Lifeline Adult Electrode Pads", h: "defibtech-lifeline-adult-pads", p: "77.40", s: "2 yr", a: true },
        ped: { t: "Lifeline Pediatric Electrode Pads", h: "defibtech-lifeline-pediatric-pads", p: "134.16", s: "2 yr", a: true },
        bat: { t: "Lifeline / Lifeline AUTO Battery (with 9V lithium)", h: "defibtech-lifeline-lifeline-auto-5-year-battery-pack-9v-lithium-battery", p: "235.97", s: "5 yr", a: true, n: "7-year option ($275.73) also available." },
        pkg: { t: "Lifeline Pad & Battery Maintenance Package", h: "defibtech-lifeline-auto-aed-maintenance-package-pads-and-battery" } },
      { m: "Lifeline VIEW / ECG / PRO",
        adult: { t: "Lifeline VIEW Adult Electrode Pads", h: "defibtech-lifeline-view-ecg-pro-adult-pads", p: "85.54", s: "2 yr", a: true },
        ped: { t: "Lifeline VIEW Pediatric Electrode Pads", h: "defibtech-lifeline-view-ecg-pro-pediatric-pads", p: "140.49", s: "2 yr", a: true },
        bat: { t: "Lifeline VIEW 4-Year Battery", h: "defibtech-lifeline-view-ecg-pro-standard-4-year-battery-pack-for-lifeline-view", p: "247.66", s: "4 yr", a: true, n: "FAA aviation option ($261.52) available." },
        pkg: { t: "Lifeline VIEW Pad & Battery Maintenance Package", h: "defibtech-lifeline-view-pro-ecg-aed-maintenance-package-pads-and-battery" } }
    ]
  };

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function priceLabel(p) {
    if (p == null) return "";
    return /^from /.test(p) ? "$" + p.slice(5) + " +" : "$" + p;
  }

  function lineCard(role, item) {
    var card = el("div", "apf-line");
    var top = el("div", "apf-line-top");
    top.appendChild(el("span", "apf-role", role));
    if (item.s && item.s !== "—") top.appendChild(el("span", "apf-life", item.s + " shelf life"));
    card.appendChild(top);
    card.appendChild(el("div", "apf-item-title", item.t));
    if (item.n) card.appendChild(el("div", "apf-note", item.n));

    var foot = el("div", "apf-line-foot");
    if (item.p) foot.appendChild(el("span", "apf-price", priceLabel(item.p)));
    if (!item.a) foot.appendChild(el("span", "apf-stock", "Call to confirm"));
    if (item.h) {
      var link = el("a", "apf-btn", "View");
      link.href = url(item.h);
      link.setAttribute("rel", "noopener");
      foot.appendChild(link);
    } else {
      var call = el("a", "apf-btn apf-btn-ghost", "Call 888-541-2337");
      call.href = "tel:18885412337";
      foot.appendChild(call);
    }
    card.appendChild(foot);
    return card;
  }

  function render(root, model) {
    var out = root.querySelector("[data-apf-results]");
    out.innerHTML = "";
    if (!model) { out.appendChild(el("p", "apf-empty", "Choose your AED model above to see the exact replacement parts it takes.")); return; }

    if (model.note) out.appendChild(el("div", "apf-callout", model.note));

    var grid = el("div", "apf-grid");
    grid.appendChild(lineCard("Adult Pads", model.adult));
    if (model.adultAlt) grid.appendChild(lineCard("Adult Pads — Alternate", model.adultAlt));
    if (model.ped) grid.appendChild(lineCard("Pediatric Pads", model.ped));
    grid.appendChild(lineCard("Battery", model.bat));
    out.appendChild(grid);

    if (model.pkg) {
      var pkg = el("div", "apf-pkg");
      pkg.appendChild(el("div", "apf-pkg-label", "Easiest option — bundle and save"));
      pkg.appendChild(el("div", "apf-pkg-title", model.pkg.t));
      var pl = el("a", "apf-btn apf-btn-pkg", "View Maintenance Package");
      pl.href = url(model.pkg.h); pl.setAttribute("rel", "noopener");
      pkg.appendChild(pl);
      out.appendChild(pkg);
    }
  }

  function init() {
    var root = document.getElementById("aed-pads-finder");
    if (!root) return; /* dormant on every other page */

    var brandSel = root.querySelector("[data-apf-brand]");
    var modelSel = root.querySelector("[data-apf-model]");
    if (!brandSel || !modelSel) return;

    Object.keys(DATA).forEach(function (b) {
      var o = document.createElement("option");
      o.value = b; o.textContent = b; brandSel.appendChild(o);
    });

    function loadModels() {
      modelSel.innerHTML = '<option value="">Select your model…</option>';
      modelSel.disabled = !brandSel.value;
      if (!brandSel.value) { render(root, null); return; }
      DATA[brandSel.value].forEach(function (m, i) {
        var o = document.createElement("option");
        o.value = i; o.textContent = m.m; modelSel.appendChild(o);
      });
      render(root, null);
    }

    brandSel.addEventListener("change", loadModels);
    modelSel.addEventListener("change", function () {
      var list = DATA[brandSel.value];
      render(root, (list && modelSel.value !== "") ? list[+modelSel.value] : null);
    });

    render(root, null);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();